/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { sigintDeleteSensor } from "../funcs/sigintDeleteSensor.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { SigintSensor } from "../models/components/sigintsensor.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  DeleteSigintSensorRequest,
  DeleteSigintSensorSecurity,
} from "../models/operations/deletesigintsensor.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type DeleteSigintSensorMutationVariables = {
  request: DeleteSigintSensorRequest;
  security?: DeleteSigintSensorSecurity | undefined;
  options?: RequestOptions;
};

export type DeleteSigintSensorMutationData = SigintSensor;

export type DeleteSigintSensorMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * deleteSensor sigint
 *
 * @remarks
 * Soft-delete a sensor and its memberships. Shared custom signals remain active.
 */
export function useDeleteSigintSensorMutation(
  options?: MutationHookOptions<
    DeleteSigintSensorMutationData,
    DeleteSigintSensorMutationError,
    DeleteSigintSensorMutationVariables
  >,
): UseMutationResult<
  DeleteSigintSensorMutationData,
  DeleteSigintSensorMutationError,
  DeleteSigintSensorMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildDeleteSigintSensorMutation(client, options),
    ...options,
  });
}

export function mutationKeyDeleteSigintSensor(): MutationKey {
  return ["@gram/client", "sigint", "deleteSensor"];
}

export function buildDeleteSigintSensorMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: DeleteSigintSensorMutationVariables,
  ) => Promise<DeleteSigintSensorMutationData>;
} {
  return {
    mutationKey: mutationKeyDeleteSigintSensor(),
    mutationFn: function deleteSigintSensorMutationFn({
      request,
      security,
      options,
    }): Promise<DeleteSigintSensorMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(sigintDeleteSensor(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
